import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { SortingState } from "./sorting-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class SortingQuestionStateProtobufSerializer
  implements Api.StateSerializationPlugin<SortingState> {
  key = {
    id: 20,
    name: { ns: "suspend-data", name: "question-state-sorting" },
    format: "protobuf"
  };

  serialize(data: SortingState): Result<Uint8Array, Api.SerializerError> {
    const message = new SortingStateProtoMessage({
      answersOrder: data.answersOrder,
    });

    return ProtobufSerializer.serialize<SortingStateProtoMessage>(
      message,
      SortingStateProtoMessage
    );
  }

  deserialize(content: Uint8Array): Result<SortingState, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<SortingStateProtoMessage>(content, SortingStateProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: SortingState = {
      answersOrder: message.answersOrder,
    };

    return ok(result);
  }
}

@Type.d("SortingStateProtoMessage")
class SortingStateProtoMessage extends Message<SortingStateProtoMessage> {
  @Field.d(1, "string", "repeated")
  answersOrder: string[];
}
